<template>
  <cs-preloader-overlay :loading="loading">
    <template v-if="deal">
      <component
        :is="currentView"
        :deal="deal"
        :language="getLanguage"
        :payment="payment"
        :project="project"
        @update="loadDeal"
      />
    </template>
  </cs-preloader-overlay>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

import OpenedSafeDeal from 'organisms/deal/OpenedSafeDeal';
import DisputedSafeDeal from 'organisms/deal/DisputedSafeDeal';
import SuccessfulSafeDeal from 'organisms/deal/SuccessfulSafeDeal';
import ClosedSafeDeal from 'organisms/deal/ClosedSafeDeal';

import HTTPService from 'services/Http';

const DEAL_STEPS = ['success', 'dispute'];

const COMPONENTS_MAP = {
  OPENED: OpenedSafeDeal,
  CHALLENGE_PROCESSING: DisputedSafeDeal,
  CHALLENGE_SUCCESS: ClosedSafeDeal,
  CLOSED: SuccessfulSafeDeal,
};

export default {
  name: 'SafeDeal',
  components: {
    OpenedSafeDeal,
    DisputedSafeDeal,
    SuccessfulSafeDeal,
    ClosedSafeDeal,
  },
  created() {
    if (this.isInvalidUrlParams) {
      this.$router.push({ name: 'service.error' });
      return;
    }

    if (this.$route.params.step === 'success') {
      this.checkClosedDeal();
    } else {
      this.loadDeal();
    }
  },
  data() {
    return {
      deal: null,
      loading: false,
      payment: null,
      project: null,
    };
  },
  computed: {
    currentView() {
      if (this.$validate.isNull(this.deal)) {
        return null;
      }

      return COMPONENTS_MAP[this.deal.status];
    },
    isInvalidUrlParams() {
      const { params, query } = this.$route;

      if (!DEAL_STEPS.includes(params.step)) {
        return true;
      }

      if (!query.publicId || !query.processToken) {
        return true;
      }

      if (this.$validate.isEmptyString(query.publicId)) {
        return true;
      }

      if (this.$validate.isEmptyString(query.processToken)) {
        return true;
      }

      return false;
    },
    ...mapGetters(['getLanguage']),
  },
  methods: {
    setData(data) {
      this.deal = data.deal;
      this.payment = data.payment;
      this.project = data.project;

      this.SET_PROVIDER(data.payment.provider);
    },
    async loadDeal() {
      this.loading = true;

      try {
        const { data } = await HTTPService.getSafeDeal({
          publicId: this.$route.query.publicId,
          processToken: this.$route.query.processToken,
        });

        this.setData(data);
        this.loading = false;
      } catch (error) {
        console.error(error);
        this.$router.push({ name: 'service.error' });
      }
    },
    async checkClosedDeal() {
      this.loading = true;

      try {
        const { data } = await HTTPService.checkClosedDeal({
          publicId: this.$route.query.publicId,
          processToken: this.$route.query.processToken,
          dealStatus: 'CLOSED',
        });

        if (!data.deal || data.deal.status !== 'CLOSED') {
          this.$router.push({ name: 'service.error' });
          return;
        }

        this.setData(data);
        this.loading = false;
      } catch (error) {
        console.error(error);
        this.$router.push({ name: 'service.error' });
      }
    },
    ...mapMutations(['SET_PROVIDER']),
  },
};
</script>

<style lang="sass" module>
  .container
    overflow: hidden
</style>
